@if (version) {
  <div class="_version">{{version}}</div>
}
@if (ready$ | async) {
  <main class="d-flex" [class.busy]="busy">
    @if (busy) {
      <div class="busy-overlay"></div>
    }
    @if (!hideNavigation) {
      <app-navigation></app-navigation>
    }
    <div class="d-flex flex-column flex-grow-1">
      <router-outlet></router-outlet>
      @if (!hideFooter) {
        <app-footer></app-footer>
      }
    </div>
  </main>
}
@if (isModalRoute) {
  <div class="fade modal-backdrop modal-backdrop--route show"></div>
}